<template>
  <div class="yk-about">
    <div class="banner">
      <el-carousel indicator-position="inside" :height="bannerHeight">
        <el-carousel-item v-for="(item, index) in imgList" :key="'banner'+index">
          <img alt="" title="" width="100%" height="auto" :src="item">
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="info">
      <h1 class="title">厚积薄发 止于至善</h1>
      <p class="title1">
        北京永康乐业科技发展有限公司，2009年成立于北京市海淀区园区，是由留美学者及清华大学毕业学生在国内行业知名专家共同指导下创立的从事化工、 生物材料、过滤材料，电池隔膜，功能性纺织等领域的研发、生产和技术服务为一体的科技企业。 公司技术上依托于清华大学、北京理工大学等国内院校并与国内多家医院和科研单位建立了战略合作关系，形成了以生物材料、环境友好材料为主的多项技术成果。
      </p>
    </div>
    <div class="listBox">
      <div class="item" v-for="(item, index) in dataList" :key="'itemTab'+index" :id="'itemTab'+index">
        <div class="tabName" :class="currentList.findIndex(val => {return val === index}) >= 0?'active':''" @click="clickName(item, index)">
          <p>{{item.title}}</p><i :class="currentList.findIndex(val => {return val === index}) >= 0?'el-icon-arrow-down':'el-icon-arrow-up'"></i>
        </div>
        <div class="text" v-show="currentList.findIndex(val => {return val === index}) >= 0" v-html="item.content"></div>
        <div class="arrow" @click="clickName(item, index)"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      dataList: [],
      currentList: [],
      imgList: [],
      bannerHeight:document.documentElement.clientWidth*537/1920+"px"
    }
  },
  mounted () {
    this.getData()
    this.getImgList()
  },
  methods: {
    getData () {
      this.$get(`/api/about`).then(res => {
        this.dataList = res.data
        if (this.$route.query && this.$route.query.name) {
          let idx = this.dataList.findIndex(val => {return val.title === this.$route.query.name})
          if (idx >= 0) {
            this.currentList = [idx]
            this.$nextTick(() => {
              let obj = $(`#itemTab${idx}`).offset()
              $('html, body').stop().animate({
                scrollTop: obj.top
              })
            })  
          } 
        }
      })
    },
    clickName (item, index) {
      let idx = this.currentList.findIndex(val => {return val === index})
      if (idx >= 0) {
        this.currentList.splice(idx, 1)
      } else {
        this.currentList.push(index)
      }
    },
    getImgList () {
      this.imgList = []
      let about = this.bannerList.find(val => {return val.typeLabel === 'about'})
      this.imgList = about.bannerList;
    },
  },
  beforeDestroy () {
  },
  watch: {
    bannerList: {
      handler() {
        this.getImgList()
      },
      deep: true
    }
  },
  components: {}
}
</script>
<style scoped lang="stylus">
.yk-about
  width 100%
  color $c1
  .banner
    width 100%
    .bannerContent
      width $pageWidth
      color $c7
      text-align center
      height 100%
      margin 0 auto
      display flex
      flex-direction column
      justify-content center
      .f1
        font-size 52px
        padding-bottom 40px
      .f2
        font-size 26px
        line-height 60px
  .info
    color $c1
    width $pageWidth
    margin 50px auto
    .title   
      font-size 48px
      font-weight 600
      margin-bottom 60px
      text-align center
    .title1
      font-size 20px
      line-height 40px
  .listBox
    width 70%
    margin 40px auto
    .item
      margin-bottom 40px
    .tabName
      padding 0 20px
      font-size 24px
      line-height 60px
      font-weight 600
      border 2px solid #D3D3D3
      display flex
      border-radius 5px
      cursor pointer
      justify-content space-between
      i
        margin-top 20px
    .active
      border 2px solid #03459D
      color #03459D
    .text
      margin-top 30px
      font-size 20px
      line-height 40px
@media screen and (max-width: 900px)
  .yk-about
    .banner
      background-color #E5EBF1
      .bannerContent
        width 94%
        margin 3% auto
        .f1
          font-size 1.3rem
        .f2
          font-size 0.7rem      
          line-height 1.5rem  
    .info
      width 94%
      text-align center
      margin 2rem auto
      .title
        font-size 1.2rem
        margin-bottom 1rem
      .title1
        font-size 0.65rem
        line-height 1.5rem
    .listBox
      width 94%
      .item
        margin-bottom 0.8rem
        .tabName
          padding 0 1rem
          line-height 3rem
          font-size 0.9rem
          i
            margin-top 1rem
        .text
          font-size 0.7rem
          line-height 1.5rem
          padding 1rem 0.5rem 2rem 0.5rem
@media screen and (max-width: 700px)
  .yk-about
    .info
      .swiperBox
        transform scale(0.6)
    .mapBox
      margin-top -9rem
      .us
        transform scale(0.5)
@media screen and (max-width: 500px)
  .yk-about
    .info
      .swiperBox
        transform scale(0.5)
    .mapBox
      margin-top -11rem
      .us
        transform scale(0.4)
</style>